import script from "./TimerBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimerBar.vue?vue&type=script&setup=true&lang=ts"

import "./TimerBar.vue?vue&type=style&index=0&id=512d5dfe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-512d5dfe"]])

export default __exports__